import React, {useState} from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import {useAppState, useUserState} from '@stores/AppStateContext';
import type {Issue} from '../../../stores/reliability/types';
import {MoreVerticalIcon} from '../../components/icons/MoreVerticalIcon';
import {Tooltip} from '../../components/Tooltip/Tooltip';
import {openIssueRowOptions} from '../../elements/context-menu/IssueRowOptions/IssueRowOptions';
import {IssueDeleteConfirmModal} from './IssueDeleteConfirmModal';

export interface IssueRowActionsProps {
    issue: Issue;
    onArchive?: (issue: Issue) => void;
    onReopen?: (issue: Issue) => void;
}

export const IssueRowActions = observer(({issue, onArchive, onReopen}: IssueRowActionsProps) => {
    const appState = useAppState();
    const userState = useUserState();
    const [deleteIssue, setDeleteIssue] = useState<Issue | null>(null);

    if (userState?.isCurrentUserReadOnly) {
        return null;
    }

    return (
        <>
            <div className="Issues-rowActions" onClick={(event) => event.stopPropagation()}>
                <Tooltip title={intl.get('tooltip.more').d('More')}>
                    <MoreVerticalIcon
                        className="Issues-rowActions__more"
                        size={20}
                        onClick={(event) => {
                            const target = event.currentTarget;
                            event.preventDefault();
                            event.stopPropagation();
                            openIssueRowOptions(appState, issue, {
                                getTargetBoundingBox: () => target.getBoundingClientRect(),
                                menuAlignment: 'end',
                            }, setDeleteIssue, onArchive, onReopen);
                        }}
                    />
                </Tooltip>
            </div>
            <IssueDeleteConfirmModal
                issue={deleteIssue}
                onClose={() => setDeleteIssue(null)}
            />
        </>
    );
});
